const baseKey = '/v1/exchange/rates'

export const exchangeRatesAPI = {
  baseKey,
}
